var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVisaoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 104,
    viewBox: "0 0 344 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_28669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 56.5894V56.1684L98.929 57.6842C95.4745 58.1053 92.2727 58.1053 88.9024 57.6842L75 56",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 74L103.5 81H108",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 81H84.802L89 74",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2901 86.2839C32.7141 82.3211 31.1686 77.5829 31.1686 72.5001C31.1686 58.2856 42.6743 47 56.5843 47C70.4942 47 82 58.3717 82 72.5001C82 86.7146 70.666 98 56.5843 98H0",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 98C145.936 98 157 86.6283 157 72.4999C157 58.2854 145.851 47 132 47C118.064 47 107 58.3715 107 72.4999C107 86.7144 118.149 98 132 98Z",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 68.5001C101 72.545 97.5449 76 93.5 76C89.4551 76 86 72.545 86 68.5001C86 64.4552 89.4551 61 93.5 61C97.5449 61 101 64.4552 101 68.5001Z",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 92C66.5986 92 75 83.3717 75 73.0001C75 62.6285 66.5986 54 56.5 54C46.4014 54 38 62.6285 38 73.0001C38 83.3717 46.4014 92 56.5 92Z",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5 92C142.599 92 151 83.3717 151 73.0001C151 62.6285 142.599 54 132.5 54C122.401 54 114 62.6285 114 73.0001C114 83.3717 122.401 92 132.5 92Z",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.083 55.5803V56C117.811 50.7117 124.651 47.5219 132.166 47.5219C139.68 47.5219 141.369 48.781 145 51.1314L135.121 39.6315C131.49 35.6023 127.184 33 121.864 33C116.545 33 114.772 34.2592 111.985 36.1898C107.679 39.3796 102.781 41.73 97.6308 42.9891C95.5199 43.4088 93.1556 43.4088 90.9603 42.9891C85.8096 41.73 80.9123 39.3796 76.606 36.1898C73.8195 34.2592 70.4421 33 66.7268 33C61.4073 33 56.8477 35.3505 53.4702 39.6315L43 51.7189C47.053 48.9489 51.7815 47.4378 57.101 47.4378C62.4205 47.4378 71.0331 50.6277 75.5083 55.4963",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 39V38.1339C80 32.6771 75.0522 28 68.7791 28C62.506 28 59.4137 31.0314 58 35.2755",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 34.9091C126.463 30.7273 122.622 28 117.841 28C113.061 28 107 32.8183 107 38.6364V40",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 100L344 100",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_28669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 104,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisaoMobile);
export default __webpack_public_path__ + "static/media/icon-visao-mobile.3edb6e40.svg";
export { ForwardRef as ReactComponent };